<template>
  <div class="small">
    <doughnut-chart :chart-data="datacollection" :height="chartHeight" :options="options"></doughnut-chart>
  </div>
</template>

<script>
import DoughnutChart from "@/components/DoughnutChart.js";

export default {
  name: "RandomDoughnut",
  components: {
    DoughnutChart
  },
  data: function() {
    return {
      chartHeight: 300,
      isConnected: false,
      datacollection: {},
      options: {
        responsive: true,
        maintainAspectRatio: false,
        color: "#FFFFFF",
        legend: {
          position: "bottom",
          labels: {
            boxWidth: 20,
            usePointStyle: true,
            fontColor: "white"
          }
        }
      }
    };
  },
  mounted() {
    this.fillData();
    let vm = this;
    setInterval(() => {
      vm.fillData();
    }, 4000);
  },
  methods: {
    fillData() {
      this.datacollection = {
        datasets: [
          {
            borderColor: ["#10354b", "#10354b"],
            backgroundColor: [
              "rgba(255, 255, 255, 0.1)",
              "rgba(66, 185, 131, 0.1)"
            ],
            data: [this.getRandomInt(), this.getRandomInt()]
          }
        ],
        labels: ["Inventory", "On Order"]
      };
    },
    getRandomInt() {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
    }
  }
};
</script>

<style>
</style>
